<ng-template #tradeTabPaneTemplate>
@for (trade of trades.controls; track trade; let i = $index) {
    <section class="tab-pane fade" id="sale-trade-{{i}}-tab">
        <div class="card" [formGroup]="trade">
            <div class="card-body">
                <div>
                    <h4 class="text-secondary" data-target="#trade-inventory-general-info-modal" data-toggle="modal" (click)="edit($event, trade.get('inventoryId').value)">
                        {{ trade.get('year').value }} {{ trade.get('make').value }} {{ trade.get('model').value }}
                    </h4>
                    <p class="small subtitle">
                        {{ trade.get('stockNumber').value }} |
                        <span class="text-muted">{{ trade.get('vinNumber').value }}</span>
                    </p>
                </div>
                <div>
                    <div class="row">
                        <div class="form-group col">
                            <currency-input [id]="'tradeInAcv' + i" [control]="trade.get('tradeInAcv')" [prefix]="'ACV'"></currency-input>
                        </div>
                        <div class="form-group col">
                            <currency-input [id]="'tradeInAllowance' + i" [control]="trade.get('tradeInAllowance')" [prefix]="'Allowance'" (committed)="changed($event)" (blurred)="changed($event)"></currency-input>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col">
                            <select [id]="'lienholder' + i" class="custom-select form-control form-control-sm form-control-sm" formControlName="lienholderContactId">
                                @for (lienholder of lienholders; track lienholder) {
                                    <option [value]="lienholder.id">{{lienholder.companyName}}</option>
                                }
                            </select>
                        </div>
                        <div class="form-group col">
                            <currency-input [id]="'tradeInPayoff' + i" [control]="trade.get('tradeInPayoff')" [prefix]="'Payoff'" (committed)="changed($event)" (blurred)="changed($event)"></currency-input>
                        </div>
                    </div>
                </div>
                <div class="actions">
                    <button title="Delete" class="btn btn-sm btn-link text-danger" data-target="#delete-modal-trade" data-toggle="modal" (click)="selectForDelete(i)" [disabled]="loading || isLocked">
                        <span class="dripicons-trash"></span>
                    </button>
                </div>
            </div>
        </div>
    </section>
}
</ng-template>

<!-- delete modal -->
<div class="modal fade" id="delete-modal-trade" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel">
    <div class="modal-dialog modal-sm modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-body d-flex flex-wrap align-items-center justify-content-center">
                <span class="uil-trash-alt text-danger display-1"></span>
                <h3 class="text-danger w-100 text-center">{{words[language][ 'delete' ] }}</h3>
                <span class="text-dark my-1 text-center">{{words[language][ 'deleteVehicle' ] }}</span>
                <button class="btn btn-danger mt-2" (click)="deleteTradeIn()" data-dismiss="delete-modal-trade" [disabled]="loading">
                    @if (loading) {
                    <span class="spinner-grow spinner-grow-sm mr-1" role="status"></span>
                    }
                    {{words[language][ 'yes' ] }}
                </button>
                <button class="btn btn-secondary mt-2 ml-2" data-dismiss="modal" id="btn-close-modal-delete-trade">No</button>
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div><!-- /.modal -->

<button type="button" id="btn-add-trade" class="d-none" data-target="#trade-inventory-general-info-modal" data-toggle="modal">&nbsp;</button>

<!-- inventory add modal -->
<div class="modal fade" id="trade-inventory-general-info-modal" tabindex="-1" role="dialog" aria-labelledby="tradeAddModal" data-target="#modal">
    <div class="modal-dialog modal-full-width modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header m-1 p-1 text-dark">
                <h5 class="px-1 text-capitalize text-dark">Trade-In</h5>
            </div>
            <div class="modal-body">
                <inventory-general-information [language]="language" [inventoryId]="inventoryId" [calledFromSale]="true" (emitterInformation$)="listenerChildrens($event)"></inventory-general-information>
            </div>
            <div class="modal-footer">
                <button class="btn btn-primary" data-dismiss="modal" id="btn-close-modal-inventory-general-info">Close</button>
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div><!-- /.modal -->
